
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { projects } from '../../mocks/projects';

interface BreadcrumbItem {
  name: string;
  url: string;
}

const BASE_URL = 'https://giedriuspetrauskas.com';

function getBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const crumbs: BreadcrumbItem[] = [{ name: 'Home', url: BASE_URL }];

  if (pathname === '/') return crumbs;

  if (pathname === '/portfolio') {
    crumbs.push({ name: 'Portfolio', url: `${BASE_URL}/portfolio` });
    return crumbs;
  }

  if (pathname.startsWith('/portfolio/') && pathname !== '/portfolio/') {
    const slug = pathname.replace('/portfolio/', '');
    const project = projects.find((p) => p.slug === slug);
    crumbs.push({ name: 'Portfolio', url: `${BASE_URL}/portfolio` });
    if (project) {
      crumbs.push({ name: project.name, url: `${BASE_URL}/portfolio/${project.slug}` });
    }
    return crumbs;
  }

  if (pathname === '/contact') {
    crumbs.push({ name: 'Contact', url: `${BASE_URL}/contact` });
    return crumbs;
  }

  if (pathname === '/privacy-policy') {
    crumbs.push({ name: 'Privacy Policy', url: `${BASE_URL}/privacy-policy` });
    return crumbs;
  }

  if (pathname === '/cookie-policy') {
    crumbs.push({ name: 'Cookie Policy', url: `${BASE_URL}/cookie-policy` });
    return crumbs;
  }

  if (pathname === '/terms-of-use') {
    crumbs.push({ name: 'Terms of Use', url: `${BASE_URL}/terms-of-use` });
    return crumbs;
  }

  return crumbs;
}

export default function BreadcrumbSchema() {
  const location = useLocation();

  useEffect(() => {
    const crumbs = getBreadcrumbs(location.pathname);

    if (crumbs.length <= 1) {
      const el = document.getElementById('schema-breadcrumb');
      if (el) el.remove();
      return;
    }

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": crumbs.map((crumb, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": crumb.name,
        "item": crumb.url
      }))
    };

    const scriptId = 'schema-breadcrumb';
    let scriptEl = document.getElementById(scriptId);
    if (!scriptEl) {
      scriptEl = document.createElement('script');
      scriptEl.id = scriptId;
      scriptEl.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptEl);
    }
    scriptEl.textContent = JSON.stringify(schema);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [location.pathname]);

  return null;
}
